export interface SalesOrderHeaderDeliveryItem {
  id: string;
  salesOrderHeaderId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  notes: string;
  salesInvoiceHeaderId: string;
  deliveryDate: Date;
  chargeDelivery: boolean;
}
